import styled, { keyframes } from 'styled-components';

export const Container = styled.div`
	position: relative;
`;

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 20px;
	width: 100%;
	margin-top: 16px;
`;

export const Info = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 8px;
	flex: 1;

	img {
		width: 32px;
	}
`;

export const Text = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	color: ${({ theme }) => theme.colors.text5};
	font-size: 12px;
	font-weight: 400;
	line-height: 14px;
	gap: 2px;

	p:last-child {
		font-weight: 700;
	}
`;

export const Line = styled.div`
	width: 1px;
	height: 28px;
	background: #dbdbdb;
`;
